// extracted by mini-css-extract-plugin
export var noConferencePage = "no-conference-page_E4xAi4BbXOJXR4OtK1Bw";
export var noConferencePageLabel = "no-conference-page__label_LAxjxPN05K1qbQdsQIzv";
export var noConferencePageWarningIcon = "no-conference-page__warning-icon_ZN7qYpLOgyCX7vZknAdv";